import { MapTo } from "@adobe/aem-react-editable-components";
import { PointsAmountBanner } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const pointsAmountBannerEditConfig = {
    emptyLabel: "PointsAmountBanner",
    isEmpty: (props) => !props ||
        !props.pointsSingular ||
        !props.pointsPlural ||
        !props.text ||
        !props.tooltipText ||
        !props.url ||
        !props.urlText,
    getProps: (props) => ({
        pointsSingular: props.pointsSingular,
        pointsPlural: props.pointsPlural,
        text: props.text,
        tooltipText: props.tooltipText,
        url: props.url,
        urlText: props.urlText,
        hoursText: props.hoursText,
        minutesText: props.minutesText,
        daysSingularText: props.daysSingularText,
        daysPluralText: props.daysPluralText,
        weeksSingularText: props.weeksSingularText,
        weeksPluralText: props.weeksPluralText,
        componentId: props.cqPath?.slice(props.cqPath.lastIndexOf("/") + 1, props.cqPath.length),
    }),
};
export default MapTo("loyalty/components/pointsamountbanner")(withAemAuthoring(PointsAmountBanner, pointsAmountBannerEditConfig));
